import { render } from "./FirstResetPasswordForm.vue?vue&type=template&id=67772958&ts=true"
import script from "./FirstResetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./FirstResetPasswordForm.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__